// usage: <div adjust-height="'.planLabelColInner'">...<div class=".planLabelColInner">...</div>...</div>
//
// REMEMBER!: adjust-height="<this is an AngularJS expression>" so think of it as straight up JavaScript. If you just
// want a string in here to specify a selector, then it has to be in quotes inside the expression like so: "'a string'".
// Otherwise it won't be valid JavaScript or a valid AngularJS expression.
//
// Automatically adjusts the height of one element to match a contained element. I would like to find a way to
// generalize this more, so it could be another element at the same level or something but I don't see any way to do
// that without additional stuff in the selector or perhaps other attributes to specify where to look.
//
// There's also an optional ah-multiplier attribute which is expected to be an expression which results in a number
// which will be multiplied by the size of the item to which we're adjusting our height. That came in handy on the
// purchase planning page where we have stacks of items appearing on some of the rows.
export default function AdjustHeightDirective($log, $timeout) {
  return {
    restrict: 'A',
    scope: {
      selector: '=adjustHeight',
      multiplier: '=ahMultiplier'
    },
    link: function ($scope, $element) {
      $timeout(function () {
        if (
          ($scope.multiplier && $scope.multiplier > 1) ||
          !$scope.multiplier
        ) {
          // Use the selector to pick a contained element, then get its size.
          var targetHeight = $element.find($scope.selector).outerHeight();

          if ($scope.multiplier) {
            targetHeight *= $scope.multiplier;
          }

          // Resize the height of this element to match the contained element.
          $element.outerHeight(targetHeight);
        }
      });
    }
  };
}
